<template>
  <section class="package-payment-methods" aria-labelledby="package-payment-methods-heading">
    <div class="package-payment-methods__copy">
      <h2 id="package-payment-methods-heading" class="package-payment-methods__heading">
        Unterstützte Zahlungsarten
      </h2>
      <p class="package-payment-methods__lead mb-0">
        Wählen Sie im Buchungsprozess die passende Zahlungsart aus.
      </p>
    </div>

    <ul class="package-payment-methods__list" aria-label="Unterstützte Zahlungsarten">
      <li
        v-for="method in paymentMethods"
        :key="method.label"
        class="package-payment-methods__item"
      >
        <span class="package-payment-methods__icon" aria-hidden="true">
          <Icon :icon="method.icon" />
        </span>
        <span class="package-payment-methods__label">{{ method.label }}</span>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'PackagePaymentMethods',
  data() {
    return {
      paymentMethods: [
        {label: 'PayPal', icon: 'fa-brands:paypal'},
        {label: 'Apple Pay', icon: 'fa-brands:apple-pay'},
        {label: 'SEPA-Lastschrift', icon: 'fa-pro-solid:building-columns'},
        {label: 'Kreditkarten: Visa, Mastercard, American Express', icon: 'fa-pro-solid:credit-card'},
      ],
    }
  },
}
</script>

<style scoped lang="scss">
.package-payment-methods {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 1.1rem;
  margin-bottom: 1.4rem;
  padding: 1rem 1.15rem;
  border: 1px solid #e3e9f0;
  background: #ffffff;
  box-shadow: 0 6px 18px rgba(10, 33, 48, 0.04);
}

.package-payment-methods__copy {
  min-width: 13rem;
}

.package-payment-methods__heading {
  margin: 0 0 0.3rem;
  font-size: 1rem;
  font-weight: 700;
  color: #10273d;
}

.package-payment-methods__lead {
  color: #5d7183;
  font-size: 0.9rem;
  line-height: 1.4;
}

.package-payment-methods__list {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.55rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.package-payment-methods__item {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  min-height: 2.35rem;
  padding: 0.45rem 0.65rem;
  border: 1px solid #d9e3ec;
  background: #f7fafc;
  color: #243f55;
  font-size: 0.86rem;
  font-weight: 600;
  line-height: 1.25;
}

.package-payment-methods__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 1.1rem;
  color: #1f6f8b;
  font-size: 1rem;
}

.package-payment-methods__label {
  min-width: 0;
}

@media (max-width: 767px) {
  .package-payment-methods {
    align-items: flex-start;
    flex-direction: column;
  }

  .package-payment-methods__copy {
    min-width: 0;
  }

  .package-payment-methods__list {
    justify-content: flex-start;
    width: 100%;
  }
}
</style>
